import React, { Component } from 'react';

import api from '../../api/api';

import loadingImg from '../../image/loading_img.gif';
import back from '../../svg/back.svg';
import deleteSvg from '../../svg/delete_small.svg';

class DisplayImage extends Component{
    constructor(props){
        super(props);
        this.state = {
            displayLoading : false,
        }
    }

    onImgLoad (){
        this.setState({
            displayLoading : true
        })
    }

    readURL(input, option) {
        if (input && option) {
            var reader = new FileReader();
            reader.onload = function (e) {
                document.getElementById('imgFull').src = e.target.result;
                return;
            };
            reader.readAsDataURL(input);
        }
    }

    render(){
        api.displayHideLoader();

        this.readURL(this.props.image , this.props.displayDeleteBtn);

        return(
            <div className="popup-back" style={{backgroundColor: "#fff"}} >
                <div className="faq-header" style={{height: "40px"}}>
                    <div className="faq-header-icon">
                        <img className="faq-header-icon-img" src={back}  onClick={this.props.back.bind(this)} alt="" />
                        
                        {
                            (this.props.displayDeleteBtn ? <img className="faq-header-icon-img-right" src={deleteSvg} onClick={this.props.deleteOption.bind(this, this.props.no)} alt="" /> : '' )
                        }
                    </div>
                </div>
                <div className="body-container" style={{marginTop: "50px"}} >
                    <img className="img-full img-loading" hidden={this.state.displayLoading} src={loadingImg} alt="" />
                    <img className="img-full" hidden={!this.state.displayLoading} id="imgFull" alt="" src={(this.props.displayDeleteBtn ? '' : this.props.image )} onLoad={this.onImgLoad.bind(this)} />
                </div>
            </div>
        )
    }
}

export default DisplayImage;



// WEBPACK FOOTER //
// ./src/components/Tickets/DisplayImage.js